module.exports = __webpack_public_path__ + "static/media/small-success-tick-square.2f4b5fd3.svg";